import { render, staticRenderFns } from "./WeaponsFirearms.vue?vue&type=template&id=6581f062"
import script from "./WeaponsFirearms.vue?vue&type=script&lang=ts"
export * from "./WeaponsFirearms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports